module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/insurance-daef829d0e0b9b73e53418f224406299.svg";